var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_c('strong',[_c('em',[_vm._v("Full Analysis Coming Soon")])])])])}]

export { render, staticRenderFns }